"use strict";

import angular from "angular";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";

angular.module("nucont.home").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.home", {
        url: "",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(/* webpackChunkName: "feature-home" */ "./home.component").then(
                () => $ocLazyLoad.inject("nucont.home")
            );
        },
        views: {
            "main@": {
                component: "emptyLayoutComponent"
            },
            "empty@nucont.home": {
                component: "homeComponent"
            }
        },
        resolve: {
            user: [
                () => {
                    let count = 0;
                    return new Promise((resolve) => {
                        const checkUser = () => {
                            if (count > 3) return resolve(true);
                            if (new UserDataAdapter().user()?.role) {
                                console.log("CHECK1!");
                                return resolve(true);
                            } else {
                                console.log("CHECK2!");
                                setTimeout(() => {
                                    count++;
                                    checkUser();
                                }, 500);
                            }
                        };
                        checkUser();
                    });
                }
            ]
        }
    });
}
